import React from 'react';

const ApplicationContext = React.createContext({});

export default ApplicationContext;



// WEBPACK FOOTER //
// ./src/components/ApplicationContext/ApplicationContext.jsx